"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var benefits = [{
  name: '会员专享价',
  icon: require('../../images/rights.png')
}, {
  name: '充值赠送',
  icon: require('../../images/rights.png')
}, {
  name: '会员专享券',
  icon: require('../../images/rights.png')
}, {
  name: '入会有礼',
  icon: require('../../images/rights.png')
}];
var _default = exports.default = {
  name: 'member_benefits',
  cname: '会员权益',
  icon: 't-icon-huiyuan-dengjiquanyi',
  configName: 'c_member_benefits',
  type: 2,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'memberBenefits',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mediaDomain', 'mobileTheme'])), {}, {
    progressShow: function progressShow() {
      // 进度条
      if (this.configObj.typeConfig.activeValue.indexOf(0) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    rightsShow: function rightsShow() {
      // 权益
      if (this.configObj.typeConfig.activeValue.indexOf(1) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        'border-radius': this.configObj.bgStyle.val ? this.configObj.bgStyle.val + 'px' : '0'
      }, {
        margin: this.configObj.mbConfig.val + 'px' + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }
      // { padding: this.configObj.upConfig.val + 'px' + ' ' + '10px' + ' ' + this.configObj.downConfig.val + 'px' },
      ];
    },
    levelColor: function levelColor() {
      return [{
        color: this.configObj.levelColor.color[0].item
      }];
    },
    //进去条
    progressBoxBg: function progressBoxBg() {
      return [{
        'padding-top': this.configObj.progressUpConfig.val + 'px',
        'padding-bottom': this.configObj.progressDownConfig.val + 'px',
        background: this.configObj.levelBgColor.color[0].item
      }];
    },
    //权益
    levelBoxBg: function levelBoxBg() {
      return [{
        'padding-top': this.configObj.rightsUpConfig.val + 'px',
        'padding-bottom': this.configObj.rightsDownConfig.val + 'px',
        background: this.configObj.rightsBgColor.color[0].item
      }];
    },
    //连接线
    lineColor: function lineColor() {
      return {
        background: this.themeStyle ? this.configObj.lineColor.color[0].item : this.themeColor
      };
    },
    achieveColor: function achieveColor() {
      return this.themeStyle ? this.configObj.achieveColor.color[0].item : this.themeColor;
    },
    notAchievedColor: function notAchievedColor() {
      return this.configObj.notAchievedColor.isShow ? this.configObj.notAchievedColor.color[0].item : '#eee';
    },
    rightsColor: function rightsColor() {
      return this.configObj.rightsColor.color[0].item;
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    },
    themeStyle: {
      handler: function handler(nVal, oVal) {
        this.configObj.achieveColor.isShow = this.configObj.themeStyleConfig.tabVal;
        this.configObj.lineColor.isShow = this.configObj.themeStyleConfig.tabVal;
      },
      deep: true
    }
  },
  data: function data() {
    return {
      currentLevel: 2,
      // 模拟当前等级：黄金会员
      levelList: [{
        name: '青铜会员',
        id: 1
      }, {
        name: '白银会员',
        id: 2
      }, {
        name: '黄金会员',
        id: 3
      }, {
        name: '铂金会员',
        id: 4
      }, {
        name: '钻石会员',
        id: 5
      }],
      benefitList: [{
        name: '会员专享价',
        icon: require('../../images/rights.png')
      }, {
        name: '充值赠送',
        icon: require('../../images/rights.png')
      }, {
        name: '会员专享券',
        icon: require('../../images/rights.png')
      }, {
        name: '入会有礼',
        icon: require('../../images/rights.png')
      }],
      defaultConfig: {
        name: 'memberBenefits',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '等级权益'
        },
        typeConfig: {
          title: '展示信息',
          tabTitle: '显示内容',
          info: '会员等级请在 会员设置>会员等级 菜单中进行设置',
          name: 'rowsNum',
          activeValue: [0, 1],
          list: [{
            val: '进度条'
          }, {
            val: '会员权益'
          }]
        },
        // 背景颜色
        levelColor: {
          tabTitle: '进度条',
          title: '等级文字',
          isShow: 1,
          color: [{
            item: '#333333'
          }],
          default: [{
            item: '#333333'
          }]
        },
        levelBgColor: {
          title: '等级背景',
          isShow: 1,
          color: [{
            item: '#FFF4EC'
          }],
          default: [{
            item: '#FFF4EC'
          }]
        },
        notAchievedColor: {
          isShow: 1,
          title: '未达成颜色',
          color: [{
            item: '#eee'
          }],
          default: [{
            item: '#eee'
          }]
        },
        //优惠券背景
        lineColor: {
          isShow: 0,
          title: '连接线颜色',
          color: [{
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }]
        },
        //色调
        themeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        achieveColor: {
          title: '达成成就色',
          isShow: 0,
          color: [{
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }]
        },
        rightsBgColor: {
          tabTitle: '权益项目',
          title: '权益背景',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        rightsColor: {
          title: '权益文字',
          isShow: 1,
          color: [{
            item: '#666666'
          }],
          default: [{
            item: '#666666'
          }]
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 10,
          min: 0,
          max: 30
        },
        // 上间距
        progressUpConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 16,
          min: 0,
          max: 100
        },
        // 下间距
        progressDownConfig: {
          title: '下边距',
          val: 16,
          min: 0,
          max: 100
        },
        rightsUpConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 12,
          min: 0,
          max: 50
        },
        // 下间距
        rightsDownConfig: {
          title: '下边距',
          val: 12,
          min: 0,
          max: 50
        },
        // 左右间距
        lrConfig: {
          tabTitle: '卡片设置',
          title: '左右边距',
          val: 12,
          min: 0,
          max: 25
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        }
      },
      configObj: null,
      themeStyle: 0,
      themeColor: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
      _this.setConfig(pageData);
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data) {
        this.configObj = data;
        this.themeStyle = data.themeStyleConfig.tabVal;
        this.themeColor = this.$options.filters.filterTheme(this.mobileTheme - 1);
      }
    }
  }
};